import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ConsultRepository } from '../../../domain/repositories/consult.repository';
import { AttentionImplementationRepositoryMapper } from './mappers/attention.repository.mapper';
import { AttentionModel } from '../../../domain/models/consult/attention.model';
import { AtenttionResponseEntity } from './entities/attention-response.entity';
import { GeneralModel } from '../../../domain/models/consult/general.model';
import { GeneralResponseModel } from '../../../domain/models/consult/general-response.model';
import { GeneralImplementationRepositoryMapper } from './mappers/general.repository.mapper';
import { GeneralResponseEntity } from './entities/general-response.entity';
import { ConsultModel } from '../../../domain/models/consult/consult.model';
import { ConsultResponseModel } from '../../../domain/models/consult/consult-response.model';
import { ConsultResponseEntity } from './entities/consult-response.entity';
import { ConsultImplementationRepositoryMapper } from './mappers/consult.repository.mapper';
import { AttentionResponseModel } from '../../../domain/models/consult/attention-response.model';
import { BackgroundImplementationRepositoryMapper } from './mappers/background.repository.mapper';
import { BackgroundModel } from '../../../domain/models/consult/background.model';
import { BackgroundResponseModel } from '../../../domain/models/consult/background-response.model';
import { BackgroundResponseEntity } from './entities/background-response.entity';
import {
  DataDiagnosticConsultModel,
  DiagnosticConsultModel,
} from '../../../domain/models/consult/diagnostic-consult.model';
import { DiagnosticResponseModel } from '../../../domain/models/consult/diagnostic-response.model';
import { DiagnosticImplementationRepositoryMapper } from './mappers/diagnostic.repository.mapper';
import { DiagnosticResponseEntity } from './entities/diagnostic-response.entity';
import { RevisionConsultModel } from '../../../domain/models/consult/revision-consult.model';
import { RevisionResponseModel } from '../../../domain/models/consult/revision-response.model';
import { RevisionResponseEntity } from './entities/revision-response.entity';
import { RevisionImplementationRepositoryMapper } from './mappers/revision.repository.mapper';
import { VitalSignsImplementationRepositoryMapper } from './mappers/vital-signs.repository.mapper';
import { VitalSignsConsultModel } from '../../../domain/models/consult/vital-signs-consult.model';
import { VitalSignsResponseModel } from '../../../domain/models/consult/vital-signs-response.model';
import { VitalSignsResponseEntity } from './entities/vital-signs-response.entity';
import { OthersConsultModel } from '../../../domain/models/consult/others-consult.model';
import { OthersResponseModel } from '../../../domain/models/consult/other-response.model';
import { OthersImplementationRepositoryMapper } from './mappers/others.repository.mapper';
import { OthersResponseEntity } from './entities/others-response.entity';
import { DocumentsImplementationRepositoryMapper } from './mappers/documents.repository.mapper';
import { DocumentsConsultModel } from '../../../domain/models/consult/documents-consult.model';
import { DocumentsResponseModel } from '../../../domain/models/consult/documents-response.model';
import { DocumentsResponseEntity } from './entities/documents-response.entity';
import { TypeDocumentsEntity } from './entities/type-documents.entity';
import { TypeDocumentsImplementationRepositoryMapper } from './mappers/type-documents.repository.mapper';
import { TypeDocumentsModel } from '../../../domain/models/consult/type-documents.model';
import { ConfirmationImplementationRepositoryMapper } from './mappers/confirmation.repository.mapper';
import { ConfirmationModel } from '../../../domain/models/consult/confirmation.model';
import { ConfirmationResponseModel } from '../../../domain/models/consult/confirmation-response.model';
import { ConfirmationResponseEntity } from './entities/confirmation-response.entity';
import { ReportByDateImplementationRepositoryMapper } from './mappers/report-by-date.repository.mapper';
import { DetalleAtencionImplementationRepositoryMapper } from './mappers/detalle-atencion.repository.mapper';
import { AttentionResumenImplementationRepositoryMapper } from './mappers/attention-resumen.repository.mapper';
import { ReportByDateModel } from '../../../domain/models/consult/report-by-date.model';
import { DetalleAtencionEntity } from './entities/detalle-atencion.entity';
import { ReportByDateEntity } from './entities/report-by-date.entity';
import { ClientModel } from '../../../domain/models/client/client.model';
import { StepServiceModel } from '../../../domain/models/consult/step-service.model';
import { StepServiceEntity } from './entities/step-service.entity';
import { SetpsServiceImplementationRepositoryMapper } from './mappers/step-service.repository.mapper';
import { DataInitialModel } from '../../../domain/models/consult/data-initial.model';
import { DataInitialResponseModel } from '../../../domain/models/consult/data-initial-response.model';
import { DataInitialImplementationRepositoryMapper } from './mappers/data-initial.repository.mapper';
import { DataInitialResponseEntity } from './entities/data-initial-response.entity';
import { DevelopmentModel } from '../../../domain/models/consult/development.model';
import { DevelopmentResponseModel } from '../../../domain/models/consult/development-response.model';
import { DevelopmentResponseEntity } from './entities/development-response.entity';
import { DevelopmentImplementationRepositoryMapper } from './mappers/development.repository.mapper';
import { ClientEntity } from '../client/entities/client.entity';
import { AttentionResumenEntity } from './entities/attention-resumen.entity';
import { TypeDiagnosticModel } from '../../../domain/models/consult/type-diagnostic.model';
import { TypeDiagnosticEntity } from './entities/type-diagnostic.entity';
import { TypeDiagnosticImplementationRepositoryMapper } from './mappers/type-diagnostic.respository.mapper';
import { TypeModalityImplementationRepositoryMapper } from './mappers/type-modality.respository.mapper';
import { TypeModalityModel } from '../../../domain/models/consult/type-modality.model';
import { TypeModalityEntity } from './entities/type-modality.entity';
import { TypeResidentialAreaModel } from '../../../domain/models/consult/type-residential-area.model';
import { TypeResidentialAreaEntity } from './entities/type-residential-area.entity';
import { TypeResidentialAreaImplementationRepositoryMapper } from './mappers/type-residential-area.respository.mapper';
import { TypeIncomeImplementationRepositoryMapper } from './mappers/type-income.respository.mapper';
import { TypeIncomeModel } from '../../../domain/models/consult/type-income.model';
import { TypeIncomeEntity } from './entities/type-income.entity';
import { TypeUserImplementationRepositoryMapper } from './mappers/type-user.repository.mapper';
import { TypeUserModel } from '../../../domain/models/consult/type-user.model';
import { TypeUserEntity } from './entities/type-user.entity';
import { ClasificationDiagnosticImplementationRepositoryMapper } from './mappers/clasification-diagnostic.mapper';
import { ClasificationDiagnosticEntity } from './entities/clasification-diagnostic.entity';
import { ClasificationDiagnosticModel } from '../../../domain/models/consult/clasification-diagnostic.model';
import { RipsModel } from '../../../domain/models/consult/rips.model';
import { RipsEntity } from './entities/rips-entity';
import { RipsImplementationRepositoryMapper } from './mappers/rips-repository.mapper';
import { ElectrocardiogramRhythmEntity } from './entities/electrocardiogram-rhythm.entity';
import { ElectrocardiogramRhythmRepositoryMapper } from './mappers/electrocardiogram-rythm-repository.mapper';
import { ElectrocardiogramWavesRepositoryMapper } from './mappers/electrocardiogram-waves-repository.mapper';
import { ElectrocardiogramRhythmModel } from '../../../domain/models/consult/electrocardiogram-rhythm.model';
import { CardiovascularScreeningImplementationRepositoryMapper } from './mappers/cardiovascular-screening.repository.mapper';
import { CardiovascularScreeningModel } from '../../../domain/models/consult/cardiovascular-screening.model';
import { CardiovascularScreeningResponseEntity } from './entities/cardiovascular-screening-response.entity';
import { CardiovascularScreeningResponseModel } from '../../../domain/models/consult/cardiovascular-screening-response.model';
import { TypeFinalityModel } from '../../../domain/models/consult/type-finality.model';
import { TypeFinalityImplementationRepositoryMapper } from './mappers/type-finality.respository.mapper';
import { TypeCauseModel } from '../../../domain/models/consult/type-cause.model';
import { TypeCauseImplementationRepositoryMapper } from './mappers/type-cause.respository,mapper';
import { ViaEnterModel } from '../../../domain/models/consult/via-enter.model';
import { ViaEnterEntity } from './entities/via-enter-response.entity';
import { ViaEnterImplementationRepositoryMapper } from './mappers/via-enter.repository.mapper';
import { ProcedureModel } from '../../../domain/models/consult/procedure.model';
import { ProcedureResponseEntity } from './entities/procedure-response.entity';
import { ProcedureResponseModel } from '../../../domain/models/consult/procedure-response.model';
import { ProcedureImplementationRepositoryMapper } from './mappers/procedure.repository.mapper';
import { OriginModel } from '../../../domain/models/consult/origin.model';
import { OriginEntity } from './entities/origin.entity';
import { OriginImplementationRepositoryMapper } from './mappers/origin.repository.mapper';
import { ExtensionImplementationRepositoryMapper } from './mappers/extension.repository.mapper';
import { ExtensionModel } from '../../../domain/models/consult/extension.model';
import { ExtensionEntity } from './entities/extension.entity';
import { InabilityModel } from '../../../domain/models/consult/inability.model';
import { InabilityResponseModel } from '../../../domain/models/consult/inability-response.model';
import { InabilityResponseEntity } from './entities/inability-response.entity';
import { InabilityImplementationRepositoryMapper } from './mappers/inability.repository.mapper';
import { ConsultOptometryModel } from '../../../domain/models/consult/consult-optometry.model';
import { ConsultOptometryResponseModel } from '../../../domain/models/consult/consult-optometry-response.model';
import { ConsultOptometryResponseEntity } from './entities/consult-optometry-response.entity';
import { ConsultOptometryImplementationRepositoryMapper } from './mappers/consult-optometry.repository.mapper';
import { BackgroundOptometryImplementationRepositoryMapper } from './mappers/background-optometry.repository.mapper';
import { BackgroundOptometryModel } from '../../../domain/models/consult/background-optometry.model';
import { BackgroundOptometryResponseEntity } from './entities/background-optometry-response.entity';
import { BackgroundOptometryResponseModel } from '../../../domain/models/consult/background-optometry-response.model';
import { TypeGlassesImplementationRepositoryMapper } from './mappers/type-glasses.respository.mapper';
import { TypeFilterGlassesImplementationRepositoryMapper } from './mappers/type-filter-glasses.respository.mapper';
import { TypeMaterialGlassesEntity } from './entities/type-material-glasses.entity';
import { TypeGlassesModel } from '../../../domain/models/consult/type-glasses.model';
import { TypeGlassesEntity } from './entities/type-glasses.entity';
import { TypeMaterialGlassesModel } from '../../../domain/models/consult/type-material-glasses.model';
import { TypeFilterGlassesModel } from '../../../domain/models/consult/type-filter-glasses.model';
import { TypeFilterGlassesEntity } from './entities/type-filter-glasses.entity';
import { LensiometryImplementationRepositoryMapper } from './mappers/lensiometry.respository.mapper';
import { LensiometryModel } from '../../../domain/models/consult/lensiometry.model';
import { LensiometryResponseEntity } from './entities/lensiometry-response.entity';
import { LensiometryResponseModel } from '../../../domain/models/consult/lensiometry-response.model';
import { OftalmoscopyImplementationRepositoryMapper } from './mappers/oftalmoscopy.respository.mapper';
import { OftalmoscopyModel } from '../../../domain/models/consult/oftalmoscopy.model';
import { OftalmoscopyResponseEntity } from './entities/oftalmoscopy-response.entity';
import { OftalmoscopyResponseModel } from '../../../domain/models/consult/oftalmoscopy-response.model';
import { VisualAcuityModel } from './entities/visual-acuity.entity';
import { VisualAcuityImplementationRepositoryMapper } from './mappers/visual-acuity.respository.mapper';
import { VisualAcuityResponseEntity } from './entities/visual-acuity-response.entity';
import { VisualAcuityResponseModel } from '../../../domain/models/consult/visual-acuity-response.model';
import { DominantEyeImplementationRepositoryMapper } from './mappers/dominant-eye.repository.mapper';
import { DominantEyeModel } from '../../../domain/models/consult/dominant-eye.model';
import { DominantEyeEntity } from './entities/dominant-eye.entity';
import { TestExternalImplementationRepositoryMapper } from './mappers/test-external.mapper';
import { TestExternalResponseModel } from '../../../domain/models/consult/test-external.response.model';
import { TestExternalModel } from '../../../domain/models/consult/test-external.model';
import { TestExternalResponseEntity } from './entities/test-external.response.entity';
import { BiomicroscopyModel } from '../../../domain/models/consult/biomicroscopy.model';
import { BiomicroscopyResponseEntity } from './entities/biomicroscopy-response.entity';
import { BiomicroscopyResponseModel } from '../../../domain/models/consult/biomicroscopy-response.model';
import { BiomicroscopyImplementationRepositoryMapper } from './mappers/biomicroscopy.repository.mapper';
import { SurfaceFilmModel } from '../../../domain/models/consult/surface-film.model';
import { SurfaceFilmResponseModel } from '../../../domain/models/consult/surface-film-response.model';
import { SurfaceFilmResponseEntity } from './entities/surface-film-response.entity';
import { SurfaceFilmImplementationRepositoryMapper } from './mappers/surface-film.repository.mapper';
import { DeviationImplementationRepositoryMapper } from './mappers/deviation.repository.mapper';
import { DeviationResponseModel } from '../../../domain/models/consult/deviation-response.model';
import { DeviationModel } from '../../../domain/models/consult/deviation.model';
import { DeviationResponseEntity } from './entities/deviation-response.entity';
import { KerotometryImplementationRepositoryMapper } from './mappers/kerotometry.repository.mapper';
import { KerotometryModel } from '../../../domain/models/consult/kerotometry.model';
import { KerotometryResponseEntity } from './entities/kerotometry-response.entity';
import { KerotometryResponseModel } from '../../../domain/models/consult/kerotometry-response.model';
import { TypeLookImplementationRepositoryMapper } from './mappers/type-look.respository.mapper';
import { TypeLookModel } from '../../../domain/models/consult/type-look.model';
import { TypeLookEntity } from './entities/type-look.entity';
import { TypeRetinoscopyImplementationRepositoryMapper } from './mappers/type-retinoscopy.respository.mapper';
import { RetinoscopyImplementationRepositoryMapper } from './mappers/retinoscopy.repository.mapper';
import { TypeRetinoscopyModel } from '../../../domain/models/consult/type-retinoscopy.model';
import { TypeRetinoscopyEntity } from './entities/type-retinoscopy.entity';
import { RetinoscopyModel } from '../../../domain/models/consult/retinoscopy.model';
import { RetinoscopyResponseEntity } from './entities/retinoscopy-response.entity';
import { RetinoscopyResponseModel } from '../../../domain/models/consult/retinoscopy-response.model';
import { SubjetiveImplementationRepositoryMapper } from './mappers/subjetive.repository.mapper';
import { SubjetiveResponseModel } from '../../../domain/models/consult/subjetive-response.model';
import { SubjetiveModel } from '../../../domain/models/consult/subjetive.model';
import { SubjetiveResponseEntity } from './entities/subjetive-response.entity';
import { TuningImplementationRepositoryMapper } from './mappers/tuning.repository.mapper';
import { TuningModel } from '../../../domain/models/consult/tuning.model';
import { TuningResponseEntity } from './entities/tuning-response.entity';
import { TuningResponseModel } from '../../../domain/models/consult/tuning-response.model';
import { PrescriptionImplementationRepositoryMapper } from './mappers/prescription.repository.mapper';
import { PrescriptionModel } from '../../../domain/models/consult/prescription.model';
import { PrescriptionResponseEntity } from './entities/prescription-response.entity';
import { PrescriptionResponseModel } from '../../../domain/models/consult/prescription-response.model';
import { MotilityModel } from '../../../domain/models/consult/motility.model';
import { MotilityResponseEntity } from './entities/motility-response.entity';
import { MotilityImplementationRepositoryMapper } from './mappers/motility.repository.mapper';
import { KappaImplementationRepositoryMapper } from './mappers/kappa.repository.mapper';
import { MotilityResponseModel } from '../../../domain/models/consult/motility-response.model';
import { KappaModel } from '../../../domain/models/consult/kappa.model';
import { KappaEntity } from './entities/kappa.entity';
import { VersionModel } from '../../../domain/models/consult/version.model';
import { VersionEntity } from './entities/version.entity';
import { VersionImplementationRepositoryMapper } from './mappers/version.repository.mapper';
import { OthersOptometryImplementationRepositoryMapper } from './mappers/others-optometry.repository.mapper';
import { OthersOptometryModel } from '../../../domain/models/consult/others-optometry.model';
import { OthersOptometryResponseModel } from '../../../domain/models/consult/other-optometry-response.model';
import { OthersOptometryResponseEntity } from './entities/others-optometry-response.entity';
import { TypeMaterialGlassesImplementationRepositoryMapper } from './mappers/type-material-glasses.respository.mapper';
import { TypeBirthModel } from '../../../domain/models/consult/type-birth.model';
import { TypeBirthEntity } from './entities/type-birth.entity';
import { TypeBirthImplementationRepositoryMapper } from './mappers/type-birth.repository.mapper';
import { BackgroundNeuropsychologyModel } from '../../../domain/models/consult/background-neuropsychology.model';
import { BackgroundNeuropsychologyResponseModel } from '../../../domain/models/consult/background-neuropsychology-response.model';
import { BackgroundNeuropsychologyResponseEntity } from './entities/background-neuropsychology-response.entity';
import { BackgroundNeuropsychologyImplementationRepositoryMapper } from './mappers/background-neuropsychology.repository.mapper';
import { DevelopmentNeuropsychologyModel } from '../../../domain/models/consult/development-neuropsychology.model';
import { DevelopmentNeuropsychologyResponseModel } from '../../../domain/models/consult/development-neuropsychology-response.model';
import { DevelopmentNeuropsychologyResponseEntity } from './entities/development-neuropsychology-response.entity';
import { DevelopmentNeuropsychologyImplementationRepositoryMapper } from './mappers/development-neuropsychology.repository.mapper';
import { CompositionImplementationNeuropsychologyRepositoryMapper } from './mappers/composition-neuropsychology.repository.mapper';
import { HistoryScholNeuropsychologyModel } from '../../../domain/models/consult/history-schol-neuropsychology.model';
import { HistoryScholNeuropsychologyResponseModel } from '../../../domain/models/consult/history-schol-neuropsychology-response.model';
import { HistoryScholNeuropsychologyResponseEntity } from './entities/history-schol-neuropsychology-response.entity';
import { HistoryScholNeuropsychologyImplementationRepositoryMapper } from './mappers/history-schol-neuropsychology.repository.mapper';
import { CompositionNeuropsychologyModel } from '../../../domain/models/consult/composition-neuropsychology.model';
import { CompositionNeuropsychologyResponseEntity } from './entities/composition-neuropsychology-response.entity';
import { CompositionNeuropsychologyResponseModel } from '../../../domain/models/consult/composition-neuropsychology-response.model';
import { SpasmPhysiotherapyImplementationRepositoryMapper } from './mappers/spasm-physiotherapy.repository.mapper';
import { SpasmPhysiotherapyResponseEntity } from './entities/spasm-physiotherapy-response.entity';
import { SpasmPhysiotherapyModel } from '../../../domain/models/consult/spasm-physiotherapy.model';
import { SpasmPhysiotherapyResponseModel } from '../../../domain/models/consult/spasm-physiotherapy-response.model';
import { RehabilitationPhysiotherapyResponseModel } from '../../../domain/models/consult/rehabilitation-physiotherapy-response.model';
import { RehabilitationPhysiotherapyModel } from '../../../domain/models/consult/rehabilitation-physiotherapy.model';
import { RehabilitationPhysiotherapyImplementationRepositoryMapper } from './mappers/rehabilitation-physiotherapy.repository.mapper';
import { RehabilitationPhysiotherapyResponseEntity } from './entities/rehabilitation-physiotherapy-response.entity';
import { AffectedAreaPhysiotherapyImplementationRepositoryMapper } from './mappers/affected-area-physiotherapy.repository.mapper';
import { AffectedAreaPhysiotherapyModel } from '../../../domain/models/consult/affected-area-physiotherapy.model';
import { AffectedAreaPhysiotherapyEntity } from './entities/affected-area-physiotherapy.entity';
import { MembersPhysiotherapyModel } from '../../../domain/models/consult/members-physiotherapy.model';
import { MembersPhysiotherapyEntity } from './entities/members-physiotherapy.entity';
import { MembersPhysiotherapyImplementationRepositoryMapper } from './mappers/members-physiotherapy.repository.mapper';
import { TypeMuscleEvaluationPhysiotherapyImplementationRepositoryMapper } from './mappers/type-muscle-evaluation-physiotherapy.repository.mapper';
import { TypeMuscleEvaluationPhysiotherapyEntity } from './entities/type-muscle-evaluation-physiotherapy.entity';
import { TypeMuscleEvaluationPhysiotherapyModel } from '../../../domain/models/consult/type-muscle-evaluation-physiotherapy.model';
import { MuscleEvaluationPhysiotherapyModel } from '../../../domain/models/consult/muscle-evaluation-physiotherapy.model';
import { MuscleEvaluationPhysiotherapyResponseEntity } from './entities/muscle-evaluation-physiotherapy-response.entity';
import { MuscleEvaluationPhysiotherapyImplementationRepositoryMapper } from './mappers/muscle-evaluation-physiotherapy.repository.mapper';
import { MuscleEvaluationPhysiotherapyResponseModel } from '../../../domain/models/consult/muscle-evaluation-physiotherapy-response.model';
import { StateArcMotionPhysiotherapyModel } from '../../../domain/models/consult/state-arc-motion-physiotherapy.model';
import { StateArcMotionPhysiotherapyEntity } from './entities/state-arc-motion-physiotherapy.entity';
import { StateArcMotionPhysiotherapyImplementationRepositoryMapper } from './mappers/state-arc-motion-physiotherapy.repository.mapper';
import { ArcMotionPhysiotherapyModel } from '../../../domain/models/consult/arc-motion.physiotherapy-response.models';
import { ArcMotionPhysiotherapyResponseEntity } from './entities/arc-motion-physiotherapy-response.entity';
import { ArcMotionPhysiotherapyImplementationRepositoryMapper } from './mappers/arc-motion-physiotherapy.repository.mapper';
import { ArcMotionPhysiotherapyResponseModel } from '../../../domain/models/consult/arc-motion-physiotherapy-response.models';
import { ActivityDailyPhysiotherapyEntity } from './entities/activity-daily.entity';
import { ActivityDailyPhysiotherapyModel } from '../../../domain/models/consult/activity-daily.model';
import { ActivityDailyPhysiotherapyImplementationRepositoryMapper } from './mappers/activity-daily.respository.mapper';
import { PainScalePhysiotherapyImplementationRepositoryMapper } from './mappers/pain-scale-physiotherapy.repository.mapper';
import { PainScalePhysiotherapyModel } from '../../../domain/models/consult/pain-scale-physiotherapy.model';
import { PainScalePhysiotherapyResponseEntity } from './entities/pain-scale-physiotherapy-response.entity';
import { ListPainScalePhysiotherapyEntity } from './entities/list-pain-scale-physiotherapy.entity';
import { ListPainScalePhysiotherapyModel } from '../../../domain/models/consult/list-pain-scale-physiotherapy.model';
import { ListPainScalePhysiotherapyImplementationRepositoryMapper } from './mappers/list-pain-scale-physiotherapy.repository.mapper';
import { HealthHabitPhysiotherapyImplementationRepositoryMapper } from './mappers/health-habit-physiotherapy.repository.mapper';
import { TypeHealthHabitPhysiotherapyImplementationRepositoryMapper } from './mappers/type-health-habit-physiotherapy.repository.mapper';
import { TypeHealthHabitPhysiotherapyModel } from '../../../domain/models/consult/type-health-habit-physiotherapy.model';
import { TypeHealthHabitPhysiotherapyEntity } from './entities/type-health-habit-physiotherapy.entity';
import { HealthHabitPhysiotherapyModel } from '../../../domain/models/consult/health-habit-physiotherapy.model';
import { HealthHabitPhysiotherapyResponseEntity } from './entities/health-habit-physiotherapy-response.entity';
import { BackgroundPhysiotherapyResponseModel } from '../../../domain/models/consult/background-physiotherapy-response.model';
import { BackgroundPhysiotherapyImplementationRepositoryMapper } from './mappers/background-physiotherapy.repository.mapper';
import { BackgroundPhysiotherapyModel } from '../../../domain/models/consult/background-physiotherapy.model';
import { BackgroundPhysiotherapyResponseEntity } from './entities/background-physiotherapy-response.entity';
import { TypeScarPhysiotherapyImplementationRepositoryMapper } from './mappers/type-scar-physiotherapy.repository.mapper';
import { TypeScarPhysiotherapyEntity } from './entities/type-scar-physiotherapy.entity';
import { TypeScarPhysiotherapyModel } from '../../../domain/models/consult/type-scar-physiotherapy.model';
import { DiagnosticMedicalRehabilityPhysiotherapyModel } from '../../../domain/models/consult/diagnostic-medical-rehability-physiotherapy.model';
import { DiagnosticMedicalRehabilityPhysiotherapyResponseEntity } from './entities/diagnostic-medical-rehability-physiotherapy-response.entity';
import { DiagnosticMedicalRehabilityPhysiotherapyResponseModel } from '../../../domain/models/consult/diagnostic-medical-rehability-physiotherapy-response.model';
import { DiagnosticMedicalRehabilityPhysiotherapyImplementationRepositoryMapper } from './mappers/diagnostic-medical-rehability-physiotherapy.repository.mapper';
import { TypeTransferPhysiotherapyModel } from '../../../domain/models/consult/type-transfer-physiotherapy.model';
import { TypeTransferPhysiotherapyImplementationRepositoryMapper } from './mappers/type-transfer-physiotherapy.repository.mapper';
import { TransferPhysiotherapyImplementationRepositoryRepositoryMapper } from './mappers/transfer-physiotherapy.repository.mapper';
import { TransferPhysiotherapyModel } from '../../../domain/models/consult/transfer-physiotherapy.model';
import { TransferPhysiotherapyResponseModel } from '../../../domain/models/consult/transfer-physiotherapy.response.model';
import { TransferPhysiotherapyResponseEntity } from './entities/transfer-physiotherapy.response.entity';
import { AnalysisMarchPhysiotherapyImplementationRepositoryMapper } from './mappers/analysis-march-physiotherapy.repository.mapper';
import { AnalysisMarchPhysiotherapyModel } from '../../../domain/models/consult/analysis-march-physiotherapy.model';
import { AnalysisMarchPhysiotherapyResponseEntity } from './entities/analysis-march-physiotherapy-response.entity';
import { AnalysisMarchPhysiotherapyResponseModel } from '../../../domain/models/consult/analysis-march-physiotherapy-response.model';
import { StaticDinamicEquilibriumNeurologyImplementationRepositoryMapper } from './mappers/static-dinamic-equilibrium-neurology.repository.mapper';
import { HypotoniaNeurologyImplementationRepositoryRepositoryMapper } from './mappers/hypotonia-neurology.repository.mapper';
import { PlanePostureNeurologyImplementationRepositoryRepositoryMapper } from './mappers/plane-posture-neurology.repository.mapper';
import { SpasticityNeurologyImplementationRepositoryRepositoryMapper } from './mappers/spasticity-neurology.repository.mapper';
import { StaticDinamicEquilibriumNeurologyEntity } from './entities/static-dinamic-equilibrium-neurology.entity';
import { StaticDinamicEquilibriumNeurologyModel } from '../../../domain/models/consult/static-dinamic-equilibrium-neurology.model';
import { SpasticityNeurologyModel } from '../../../domain/models/consult/spasticity-neurology.model';
import { SpasticityNeurologyEntity } from './entities/spasticity-neurology.entity';
import { HypotoniaNeurologyEntity } from './entities/hypotonia-neurology.entity';
import { HypotoniaNeurologyModel } from '../../../domain/models/consult/hypotonia-neurology.model';
import { PlanePostureNeurologyEntity } from './entities/plane-posture-neurology.entity';
import { PlanePostureNeurologyModel } from '../../../domain/models/consult/plane-posture-neurology.model';
import { ExplorationNeurologyImplementationRepositoryRepositoryMapper } from './mappers/exploration-neurology.repository.mapper';
import { ExplorationNeurologyResponseEntity } from './entities/exploration-neurology-response.entity';
import { ExplorationNeurologyModel } from '../../../domain/models/consult/exploration-neurology.model';
import { ExplorationNeurologyResponseModel } from '../../../domain/models/consult/exploration-neurology-response.model';
import { ConsentImplementationRepositoryMapper } from './mappers/consent.repository.mapper';
import { ConsentResponseModel } from '../../../domain/models/consult/consent-response.model';
import { ConsentResponseEntity } from './entities/consent-response.entity';
import { ConsentConsultModel } from '../../../domain/models/consult/consent.model';
import { TypeAvailableDocumentModel } from '../../../domain/models/consult/type-available-document.model';
import { TypeAvailableDocumentEntity } from './entities/type-available-document.entity';
import { TypeAvailableDocumentImplementationRepositoryMapper } from './mappers/type-available-document.mapper';
import { FacturaTerceroModel } from '../../../domain/models/consult/factura-tercero.model';
import { FacturaTerceroResponseEntity } from './entities/factura-tercero-response.entity';
import { FacturaTerceroImplementationRepositoryMapper } from './mappers/factura-tercero-repository.mapper';
import { FacturaTerceroResponseModel } from '../../../domain/models/consult/factura-tercero-response.model';
import { ConsentByIdImplementationRepositoryMapper } from './mappers/consent-by-id.repository.mapper';
import { VitalSignsMedicalImplementationRepositoryMapper } from './mappers/vital-signs-medical.repository.mapper';
import { VitalSignsMedicalResponseEntity } from './entities/vital-signs-medical-response.entity';
import { VitalSignsMedicalConsultModel } from '../../../domain/models/consult/vital-signs-medical.consult.model';
import { VitalSignsMedicalResponseModel } from '../../../domain/models/consult/vital-signs-medical.response.model';
import { TestFisicalImplementationRepositoryMapper } from './mappers/test-fisical.mapper';
import { TestFisicalResponseModel } from '../../../domain/models/consult/test-fisical.response.model';
import { TestFisicalModel } from '../../../domain/models/consult/test-fisical.model';
import { TestFisicalResponseEntity } from './entities/test-fisical.response.entity';
import { TypeStateTestFisicalModel } from '../../../domain/models/consult/type-state-test-medical.model';
import { TypeStateTestFisicalEntity } from './entities/type-state-test-medical.entity';
import { TypeStateTestFisicalImplementationRepositoryMapper } from './mappers/type-state-test-fisical.respository,mapper';
import { DevelopmentConsultOccupationalTherapyImplementationRepositoryMapper } from './mappers/development-consult-occupational-therapy.repository.mapper';
import { DevelopmentConsultOccupationalTherapyModel } from '../../../domain/models/consult/development-consult-occupational-therapy.model';
import { DevelopmentConsultOccupationalTherapyResponseModel } from '../../../domain/models/consult/development-consult-occupational-therapy-response.model';
import { DevelopmentConsultOccupationalTherapyResponseEntity } from './entities/development-consult-occupational-therapy-response.entity';
import { MedicationImplementationRepositoryMapper } from './mappers/medications.repository.mapper';
import { DoseImplementationRepositoryMapper } from './mappers/dose.repository.mapper';
import { UnitsTimeImplementationRepositoryMapper } from './mappers/units-time.repository.mapper';
import { RoutesAministrationImplementationRepositoryMapper } from './mappers/routes-administration.repository.mapper';
import { CalculatedFormulaImplementationRepositoryMapper } from './mappers/calculated-formula.repository.mapper';
import { MedicationModel } from './entities/medications.entity';
import { MedicationEntity } from '../../../domain/models/consult/medications.entity';
import { DoseModel } from '../../../domain/models/consult/dose.model';
import { DoseEntity } from './entities/dose.entity';
import { UnitsTimeModel } from '../../../domain/models/consult/units-time.model';
import { UnitsTimeEntity } from './entities/units-time.entity';
import { RoutesAdministrationModel } from '../../../domain/models/consult/routes-administration.model';
import { RoutesAdministrationEntity } from './entities/routes-administration.entity';
import { CalculatedFormulaEntity } from './entities/calculated-formula.entity';
import { CalculatedFormulaRequestModel } from '../../../domain/models/consult/calculated-formula-request.model';
import { TypeProcedureImplementationRepositoryMapper } from './mappers/type-procedure.repository.mapper';
import { TypeProcedureModel } from '../../../domain/models/consult/type-procedure.model';
import { TypeProcedureEntity } from './entities/type-procedure.entity';
import { ProcedureNonSurgicalModel } from '../../../domain/models/consult/procedure-non-surgical.model';
import { ProcedureNonSurgicalEntity } from './entities/procedure-non-surgical.entity';
import { MedicationRequestModel } from '../../../domain/models/consult/medication-request.model';
import { ProcedureMedicationResponseEntity } from './entities/procedure-medication-response.entity';
import { ProcedureMedicationResponseModel } from '../../../domain/models/consult/procedure-medication-response.model';
import { ProcedureNonSurgicalImplementationRepositoryMapper } from './mappers/procedure-non-surgical.repository.mapper';
import { ProcedureMedicationImplementationRepositoryMapper } from './mappers/procedure-medication.repository.mapper';
import { ProcedureAtenttionImplementationRepositoryMapper } from './mappers/procedure-attention.repository.mapper';
import { ProcedureAtenttionRequestModel } from '../../../domain/models/consult/procedure-atenttion-request.model';
import { ProcedureAtenttionModel } from '../../../domain/models/consult/procedure-atenttion.model';
import { ProcedureAtenttionEntity } from './entities/procedure-atenttion.entity';
import { DataBasicAttentionEntity } from './entities/data-basic-atenttion.entity';
import { DataBasicAttentionImplementationRepositoryMapper } from './mappers/data-basic-attention.repository.mapper';
import {  TeleconsultaInsertResponseEntity } from './entities/teleconsulta-insert-response.entity';
import { TeleconsultaInsertImplementationRepositoryMapper } from './mappers/teleconsulta-insert.repository.mapper';
import { TeleconsultaActivateImplementationRepositoryMapper } from './mappers/teleconsulta-activate.repository.mapper';
import { TeleconsultaActivateResponseEntity } from './entities/teleconsulta.activate-response.entity';


import { TeleconsultaImplementationRepositoryMapper }
from './mappers/teleconsulta.repository.mapper';


import { TeleconsultaModel }
from '../../../domain/models/consult/teleconsulta.model';


import {
  TeleconsultaEntity
}
from './entities/teleconsulta.entity';
import { ReprocessDocumentStartImplementationRepositoryMapper } from './mappers/reprocess-document-start.mapper';
import { ReprocessAttentionsListImplementationRepositoryMapper } from './mappers/reprocess-attentions-list.mapper';
import { ReprocessStartResponseEntity } from './entities/reprocess-start-response.entity';
import { ReprocessDocumentsAttentionResponseEntity } from './entities/reprocess-documents-attention-response.entity';
import { FiltersReprocessDocumentsModel } from '../../../domain/models/consult/filters-reprocess-documents.model';
import { ReprocessStartRequestModel } from '../../../domain/models/consult/reprocess-documents-start-request.model';
import { AttentionStateImplementationRepositoryMapper } from './mappers/attention-state.repository.mapper';
import { AttentionStateEntity } from './entities/attention-state.entity';
import { AttentionStateModel } from '../../../domain/models/consult/attention-state.model';

@Injectable({
  providedIn: 'root',
})
export class ConsultImplementationRepository extends ConsultRepository {
  attention = new AttentionImplementationRepositoryMapper();
  facturaTercero = new FacturaTerceroImplementationRepositoryMapper();
  general = new GeneralImplementationRepositoryMapper();
  consult = new ConsultImplementationRepositoryMapper();
  background = new BackgroundImplementationRepositoryMapper();
  diagnostic = new DiagnosticImplementationRepositoryMapper();
  revision = new RevisionImplementationRepositoryMapper();
  vital = new VitalSignsImplementationRepositoryMapper();
  vitalMedical = new VitalSignsMedicalImplementationRepositoryMapper();
  other = new OthersImplementationRepositoryMapper();
  documents = new DocumentsImplementationRepositoryMapper();
  typeDocument = new TypeDocumentsImplementationRepositoryMapper();
  typeDiagnostic = new TypeDiagnosticImplementationRepositoryMapper();
  typeModality = new TypeModalityImplementationRepositoryMapper();
  typeFinality = new TypeFinalityImplementationRepositoryMapper();
  typeCause = new TypeCauseImplementationRepositoryMapper();
  typeIncome = new TypeIncomeImplementationRepositoryMapper();
  typeStateTestFisical =
    new TypeStateTestFisicalImplementationRepositoryMapper();
  typeResidential = new TypeResidentialAreaImplementationRepositoryMapper();
  confirmation = new ConfirmationImplementationRepositoryMapper();
  report = new ReportByDateImplementationRepositoryMapper();
  detalleAtencion = new DetalleAtencionImplementationRepositoryMapper();
  resume = new AttentionResumenImplementationRepositoryMapper();
  stepService = new SetpsServiceImplementationRepositoryMapper();
  dataInitial = new DataInitialImplementationRepositoryMapper();
  development = new DevelopmentImplementationRepositoryMapper();
  cancel = new AttentionImplementationRepositoryMapper();
  typeUser = new TypeUserImplementationRepositoryMapper();
  clasiDiagnostic = new ClasificationDiagnosticImplementationRepositoryMapper();
  reportRips = new RipsImplementationRepositoryMapper();
  electroRhythm = new ElectrocardiogramRhythmRepositoryMapper();
  electroWaves = new ElectrocardiogramWavesRepositoryMapper();
  viaEnter = new ViaEnterImplementationRepositoryMapper();
  vitalCardio = new CardiovascularScreeningImplementationRepositoryMapper();
  procedure = new ProcedureImplementationRepositoryMapper();
  inability = new InabilityImplementationRepositoryMapper();
  origin = new OriginImplementationRepositoryMapper();
  extension = new ExtensionImplementationRepositoryMapper();
  consultOptometry = new ConsultOptometryImplementationRepositoryMapper();
  backgroundOptometry = new BackgroundOptometryImplementationRepositoryMapper();
  typeGlasses = new TypeGlassesImplementationRepositoryMapper();
  typeFilerGlasses = new TypeFilterGlassesImplementationRepositoryMapper();
  typeMaterialGlasses = new TypeMaterialGlassesImplementationRepositoryMapper();
  lensiometry = new LensiometryImplementationRepositoryMapper();
  oftalmoscopy = new OftalmoscopyImplementationRepositoryMapper();
  visual = new VisualAcuityImplementationRepositoryMapper();
  dominantEye = new DominantEyeImplementationRepositoryMapper();
  testExternal = new TestExternalImplementationRepositoryMapper();
  testFisical = new TestFisicalImplementationRepositoryMapper();
  biomicros = new BiomicroscopyImplementationRepositoryMapper();
  surface = new SurfaceFilmImplementationRepositoryMapper();
  deviation = new DeviationImplementationRepositoryMapper();
  keroto = new KerotometryImplementationRepositoryMapper();
  typeLook = new TypeLookImplementationRepositoryMapper();
  typeRetinos = new TypeRetinoscopyImplementationRepositoryMapper();
  retinoscopy = new RetinoscopyImplementationRepositoryMapper();
  subjetive = new SubjetiveImplementationRepositoryMapper();
  tuning = new TuningImplementationRepositoryMapper();
  prescription = new PrescriptionImplementationRepositoryMapper();
  motility = new MotilityImplementationRepositoryMapper();
  kappa = new KappaImplementationRepositoryMapper();
  version = new VersionImplementationRepositoryMapper();
  otherOpto = new OthersOptometryImplementationRepositoryMapper();
  typeBirth = new TypeBirthImplementationRepositoryMapper();
  backgroundNeuropsychology =
    new BackgroundNeuropsychologyImplementationRepositoryMapper();
  developmentNeuropsychology =
    new DevelopmentNeuropsychologyImplementationRepositoryMapper();
  compositionNeuropsychology =
    new CompositionImplementationNeuropsychologyRepositoryMapper();
  historyNeuropsychology =
    new HistoryScholNeuropsychologyImplementationRepositoryMapper();
  spasm = new SpasmPhysiotherapyImplementationRepositoryMapper();
  rehab = new RehabilitationPhysiotherapyImplementationRepositoryMapper();
  areaAffect = new AffectedAreaPhysiotherapyImplementationRepositoryMapper();
  membersPhysio = new MembersPhysiotherapyImplementationRepositoryMapper();
  muscle =
    new TypeMuscleEvaluationPhysiotherapyImplementationRepositoryMapper();
  muscleEva = new MuscleEvaluationPhysiotherapyImplementationRepositoryMapper();
  membersMotion = new MembersPhysiotherapyImplementationRepositoryMapper();
  stateArcMotion =
    new StateArcMotionPhysiotherapyImplementationRepositoryMapper();
  arcMotions = new ArcMotionPhysiotherapyImplementationRepositoryMapper();
  activityDaily =
    new ActivityDailyPhysiotherapyImplementationRepositoryMapper();
  painScale = new PainScalePhysiotherapyImplementationRepositoryMapper();
  listPain = new ListPainScalePhysiotherapyImplementationRepositoryMapper();
  healthHabit = new HealthHabitPhysiotherapyImplementationRepositoryMapper();
  typeHealthHabit =
    new TypeHealthHabitPhysiotherapyImplementationRepositoryMapper();
  backgroundPhysiotherapy =
    new BackgroundPhysiotherapyImplementationRepositoryMapper();
  typeScarPhysiotherapy =
    new TypeScarPhysiotherapyImplementationRepositoryMapper();
  diagnosticMedicalRehabilityPhysiotherapy =
    new DiagnosticMedicalRehabilityPhysiotherapyImplementationRepositoryMapper();
  typeTransfer = new TypeTransferPhysiotherapyImplementationRepositoryMapper();
  transfer =
    new TransferPhysiotherapyImplementationRepositoryRepositoryMapper();
  analysisMarchPhysiotherapy =
    new AnalysisMarchPhysiotherapyImplementationRepositoryMapper();
  staticDinamic =
    new StaticDinamicEquilibriumNeurologyImplementationRepositoryMapper();
  hypotonia = new HypotoniaNeurologyImplementationRepositoryRepositoryMapper();
  planePosture =
    new PlanePostureNeurologyImplementationRepositoryRepositoryMapper();
  spasticity =
    new SpasticityNeurologyImplementationRepositoryRepositoryMapper();
  exploration =
    new ExplorationNeurologyImplementationRepositoryRepositoryMapper();
  consent = new ConsentImplementationRepositoryMapper();
  typeAvailableDocument =
    new TypeAvailableDocumentImplementationRepositoryMapper();
  consentbyId = new ConsentByIdImplementationRepositoryMapper();
  developmentConsult = new DevelopmentConsultOccupationalTherapyImplementationRepositoryMapper();
  medication = new MedicationImplementationRepositoryMapper();
  dose = new DoseImplementationRepositoryMapper();
  units = new UnitsTimeImplementationRepositoryMapper();
  routesAdmin = new RoutesAministrationImplementationRepositoryMapper();
  calculatedForm = new CalculatedFormulaImplementationRepositoryMapper();
  typeProcedure = new TypeProcedureImplementationRepositoryMapper();
  procedureNonSurgical = new ProcedureNonSurgicalImplementationRepositoryMapper();
  procedureMedication = new ProcedureMedicationImplementationRepositoryMapper();
  procedureAtenttion = new ProcedureAtenttionImplementationRepositoryMapper();
  dataBasic = new DataBasicAttentionImplementationRepositoryMapper();
  teleconsultaInsert = new TeleconsultaInsertImplementationRepositoryMapper();
  teleconsultaActivate = new TeleconsultaActivateImplementationRepositoryMapper();
  teleconsulta = new TeleconsultaImplementationRepositoryMapper();
  reprocessDocumentStart = new ReprocessDocumentStartImplementationRepositoryMapper();
  reprocessAttentionList = new ReprocessAttentionsListImplementationRepositoryMapper();
  attentionState = new AttentionStateImplementationRepositoryMapper();

  url = environment.baseUrl;
  constructor(private http: HttpClient) {
    super();
  }

  override getTypeDocuments(): Observable<TypeDocumentsModel> {
    return this.http
      .get<TypeDocumentsEntity>(`${this.url}/TiposDocumentoAtencion/GetAll`)
      .pipe(map(this.typeDocument.mapFrom));
  }
  override getAttentionReportByDate(params: {
    DateInit: Date;
    DateEnd: Date;
    IdEmpresa: string;
  }): Observable<ReportByDateModel> {
    return this.http
      .get<ReportByDateEntity>(
        `${this.url}/Atenciones/GetAtencionesReportByDate/${params.DateInit}/${params.DateEnd}`
      )
      .pipe(map(this.report.mapFrom));
  }
  override getDetalleAtencion(params: {
    fechaInicio: Date;
    fechaFin: Date;
  }): Observable<DetalleAtencionEntity> {
    return this.http
      .post<DetalleAtencionEntity>(
        `${this.url}/ReportesDetalleAtencion/DetalleAtencionGet`,
        params
      )
      .pipe(map(this.detalleAtencion.mapFrom));
  }
  override getRipsReportByDate(params: {
    DateInit: Date;
    DateEnd: Date;
    idEnablingsCode: string;
    idNationality: string;
  }): Observable<RipsModel> {
    return this.http
      .get<RipsEntity>(
        `${this.url}/OperacionesRIPS/GetRIPSReportByDate/${params.DateInit}/${params.DateEnd}/${params.idEnablingsCode}/${params.idNationality}`
      )
      .pipe(map(this.reportRips.mapFrom));
  }
  override getTypeDiagnostic(): Observable<TypeDiagnosticModel> {
    return this.http
      .get<TypeDiagnosticEntity>(`${this.url}/TiposDiagnostico/GetAll`)
      .pipe(map(this.typeDiagnostic.mapFrom));
  }
  override getTypeResidentialArea(): Observable<TypeResidentialAreaModel> {
    return this.http
      .get<TypeResidentialAreaEntity>(`${this.url}/TiposZonaResidencia/GetAll`)
      .pipe(map(this.typeResidential.mapFrom));
  }
  override getTypeModality(): Observable<TypeModalityModel> {
    return this.http
      .get<TypeModalityEntity>(`${this.url}/TiposModalidad/GetAll`)
      .pipe(map(this.typeModality.mapFrom));
  }

  override getTypeCause(): Observable<TypeCauseModel> {
    return this.http
      .get<TypeModalityEntity>(`${this.url}/CausasConsulta/GetAll`)
      .pipe(map(this.typeCause.mapFrom));
  }

  override getTypeFinality(): Observable<TypeFinalityModel> {
    return this.http
      .get<TypeModalityEntity>(`${this.url}/FinalidadesConsulta/GetAll`)
      .pipe(map(this.typeFinality.mapFrom));
  }

  override getTypeModalityById(params: {
    id: string;
  }): Observable<TypeModalityModel> {
    return this.http
      .post<TypeModalityEntity>(
        `${this.url}/ServiciosEmpresasTipoModalidad/GetListByCompanyServicesId`,
        params
      )
      .pipe(map(this.typeModality.mapFrom));
  }

  override getTypeIncome(): Observable<TypeIncomeModel> {
    return this.http
      .get<TypeIncomeEntity>(`${this.url}/TiposRecaudo/GetAll`)
      .pipe(map(this.typeIncome.mapFrom));
  }

  override getTypeStateTestFisical(): Observable<TypeStateTestFisicalModel> {
    return this.http
      .post<TypeStateTestFisicalEntity>(
        `${this.url}/ExamenFisicoAtencion/GetEstadosExamenFisico`,
        ''
      )
      .pipe(map(this.typeStateTestFisical.mapFrom));
  }

  override getTypeConsult(
    idTypeService: string
  ): Observable<TypeDocumentsModel> {
    return this.http
      .post<TypeDocumentsEntity>(
        `${this.url}/TiposConsulta/GetByClientIdByCompanyServiceId`,
        { idServicioEmpresa: idTypeService }
      )
      .pipe(map(this.typeDocument.mapFrom));
  }

  override getTypeUser(): Observable<TypeUserModel> {
    return this.http
      .get<TypeUserEntity>(`${this.url}/TiposUsuario/GetAll`)
      .pipe(map(this.typeUser.mapFrom));
  }

  override getDocumentsByClient(params: {
    id: string;
  }): Observable<AttentionResumenEntity> {
    return this.http
      .post(
        `${this.url}/DocumentosAtencion/DocumentsAttentionByClientId`,
        params
      )
      .pipe(map(this.resume.mapFrom));
  }

  override getAttentionInProgress(params: {
    idCliente: string;
  }): Observable<AttentionResumenEntity> {
    return this.http
      .get(
        `${this.url}/Atenciones/GetAttentionsInProgressByClientId/${params.idCliente}`
      )
      .pipe(map(this.resume.mapFrom));
  }

    override getAttentionDataBasicById(params: {
    IdAttention: string;
  }): Observable<DataBasicAttentionEntity> {
    return this.http
      .get(
        `${this.url}/Atenciones/GetDatosBasicosAtencionById/${params.IdAttention}`
      )
      .pipe(map(this.dataBasic.mapFrom));
  }

  override getLastAttention(params: {
    id: string;
  }): Observable<AttentionResumenEntity> {
    return this.http
      .post(`${this.url}/Atenciones/UltimaAtencion`, params)
      .pipe(map(this.resume.mapFrom));
  }

  override getAttentionAllStates(params: {
    idCliente: string;
  }): Observable<AttentionResumenEntity> {
    return this.http
      .get(
        `${this.url}/Atenciones/GetAttentionsAllStatesByClientId/${params.idCliente}`
      )
      .pipe(map(this.resume.mapFrom));
  }
  override getTypeClasificationDiagnostic(): Observable<ClasificationDiagnosticEntity> {
    return this.http
      .get<ClasificationDiagnosticModel>(
        `${this.url}/ClasificacionesDiagnostico/GetAll`
      )
      .pipe(map(this.clasiDiagnostic.mapFrom));
  }
  override getAttentionConsecutive(params: {
    IdAttention: string;
  }): Observable<ClientModel> {
    return this.http
      .get<ClientModel>(
        `${this.url}/Atenciones/GetAtencionById/${params.IdAttention}`
      )
      .pipe(map(this.resume.mapFrom));
  }

    override getAttentionByStep(params: {
    IdAttention: string, IdStep:string
  }): Observable<AttentionResumenEntity> {
    return this.http
      .get<AttentionResumenEntity>(
        `${this.url}/Atenciones/GetAtencionById/${params.IdAttention}/${params.IdStep}`
      )
      .pipe(map(this.resume.mapFrom));
  }

  override getStepService(params: {
    IdService: string;
  }): Observable<StepServiceModel> {
    return this.http
      .get<StepServiceEntity>(
        `${this.url}/StepsServicio/GetListByServiceId?idServicio=${params.IdService}`
      )
      .pipe(map(this.stepService.mapFrom));
  }
  override getElectrocardiogramRhythm(): Observable<ElectrocardiogramRhythmModel> {
    return this.http
      .get<ElectrocardiogramRhythmEntity>(
        `${this.url}/RitmosElectrocardiograma/GetAll`
      )
      .pipe(map(this.electroRhythm.mapFrom));
  }
  override getElectrocardiogramWaves(): Observable<TypeDocumentsModel> {
    return this.http
      .get<TypeDocumentsEntity>(`${this.url}/OndasElectrocardiograma/GetAll`)
      .pipe(map(this.electroWaves.mapFrom));
  }
  override getViaEnter(): Observable<ViaEnterModel> {
    return this.http
      .get<ViaEnterEntity>(`${this.url}/ViasIngreso/GetAll`)
      .pipe(map(this.viaEnter.mapFrom));
  }

  override getOrigin(): Observable<OriginModel> {
    return this.http
      .get<OriginEntity>(`${this.url}/Origenes/GetAll`)
      .pipe(map(this.origin.mapFrom));
  }

  override getExtension(): Observable<ExtensionModel> {
    return this.http
      .get<ExtensionEntity>(`${this.url}/Prorrogas/GetAll`)
      .pipe(map(this.extension.mapFrom));
  }

  override getTypeGlasses(): Observable<TypeGlassesModel> {
    return this.http
      .get<TypeGlassesEntity>(
        `${this.url}/LensiometriasAtencion/TiposLentesGetAll`
      )
      .pipe(map(this.typeGlasses.mapFrom));
  }

  override getTypeMaterialGlasses(): Observable<TypeMaterialGlassesModel> {
    return this.http
      .get<TypeMaterialGlassesEntity>(
        `${this.url}/LensiometriasAtencion/MaterialesGetAll`
      )
      .pipe(map(this.typeMaterialGlasses.mapFrom));
  }

  override getTypeFilterGlasses(): Observable<TypeFilterGlassesModel> {
    return this.http
      .get<TypeFilterGlassesEntity>(
        `${this.url}/LensiometriasAtencion/FiltrosGetAll`
      )
      .pipe(map(this.typeFilerGlasses.mapFrom));
  }

  override getDominantEye(): Observable<DominantEyeModel> {
    return this.http
      .get<DominantEyeEntity>(`${this.url}/AgudezasVisualesAtencion/OjosGetAll`)
      .pipe(map(this.dominantEye.mapFrom));
  }


  override getTypeLook(): Observable<TypeLookModel> {
    return this.http
      .get<TypeLookEntity>(`${this.url}/QueratometriasAtencion/MirasGetAll`)
      .pipe(map(this.typeLook.mapFrom));
  }

  override getTypeRetinoscopy(): Observable<TypeRetinoscopyModel> {
    return this.http
      .get<TypeRetinoscopyEntity>(
        `${this.url}/RetinoscopiasAtencion/TiposRetinoscopiasGetAll`
      )
      .pipe(map(this.typeRetinos.mapFrom));
  }

  override getKappa(): Observable<KappaModel> {
    return this.http
      .get<KappaEntity>(`${this.url}/MotilidadesOcularesAtencion/KappasGetAll`)
      .pipe(map(this.kappa.mapFrom));
  }

  override getVersion(): Observable<VersionModel> {
    return this.http
      .get<VersionEntity>(
        `${this.url}/MotilidadesOcularesAtencion/VersionesGetAll`
      )
      .pipe(map(this.version.mapFrom));
  }

  override getTypeBirth(): Observable<TypeBirthModel> {
    return this.http
      .get<TypeBirthEntity>(`${this.url}/TiposParto/GetAll`)
      .pipe(map(this.typeBirth.mapFrom));
  }

  override getAffectedAreaPhysiotherapy(): Observable<AffectedAreaPhysiotherapyModel> {
    return this.http
      .get<AffectedAreaPhysiotherapyEntity>(
        `${this.url}/EvaluacionMuscularAtencion/GetZonaAfectacionMuscular`
      )
      .pipe(map(this.areaAffect.mapFrom));
  }

  override getMembersPhysiotherapy(params: {
    idZonaAfectacionMuscular: string;
  }): Observable<MembersPhysiotherapyModel> {
    return this.http
      .post<MembersPhysiotherapyEntity>(
        `${this.url}/EvaluacionMuscularAtencion/GetMiembros`,
        params
      )
      .pipe(map(this.membersPhysio.mapFrom));
  }

  override getTypeMuscleEvaluationPhysiotherapy(): Observable<TypeMuscleEvaluationPhysiotherapyModel> {
    return this.http
      .get<TypeMuscleEvaluationPhysiotherapyEntity>(
        `${this.url}/EvaluacionMuscularAtencion/GetEvaluacionMuscular`
      )
      .pipe(map(this.muscle.mapFrom));
  }

  override getStateArcMotionPhysiotherapy(): Observable<StateArcMotionPhysiotherapyModel> {
    return this.http
      .get<StateArcMotionPhysiotherapyEntity>(
        `${this.url}/ArcoMovimientoAtencion/GetEstadoArcoMovilidad`
      )
      .pipe(map(this.stateArcMotion.mapFrom));
  }

  override getActivityDailyPhysiotherapyPhysiotherapy(): Observable<ActivityDailyPhysiotherapyModel> {
    return this.http
      .get<ActivityDailyPhysiotherapyEntity>(
        `${this.url}/ActividadesVidaDiaria/GetAll`
      )
      .pipe(map(this.activityDaily.mapFrom));
  }

  override getListPainScalePhysiotherapy(): Observable<ListPainScalePhysiotherapyModel> {
    return this.http
      .get<ListPainScalePhysiotherapyEntity>(`${this.url}/EscalasDolor/GetAll`)
      .pipe(map(this.listPain.mapFrom));
  }

  override getTypeHealthHabitPhysiotherapy(): Observable<TypeHealthHabitPhysiotherapyModel> {
    return this.http
      .get<TypeHealthHabitPhysiotherapyEntity>(
        `${this.url}/HabitoSaludAtencion/GetHabitoVidaDiaria`
      )
      .pipe(map(this.typeHealthHabit.mapFrom));
  }

  override getTypeScarPhysiotherapy(): Observable<TypeScarPhysiotherapyModel> {
    return this.http
      .get<TypeScarPhysiotherapyEntity>(
        `${this.url}/DiagnosticoMedicoRehabilitacionAtencion/GetTiposCicatriz`
      )
      .pipe(map(this.typeScarPhysiotherapy.mapFrom));
  }

  override getTypeTransferPhysiotherapy(): Observable<TypeTransferPhysiotherapyModel> {
    return this.http
      .get<TypeScarPhysiotherapyEntity>(
        `${this.url}/TrasladosMarchaDeambulacionAtencion/GetOpcionesValoracion`
      )
      .pipe(map(this.typeTransfer.mapFrom));
  }

  override getSpasticityNeurology(): Observable<SpasticityNeurologyModel> {
    return this.http
      .get<SpasticityNeurologyEntity>(
        `${this.url}/ExploracionNeurologicaAtencion/GetEspasticidad`
      )
      .pipe(map(this.spasticity.mapFrom));
  }

  override getHypotoniaNeurology(): Observable<HypotoniaNeurologyModel> {
    return this.http
      .get<HypotoniaNeurologyEntity>(
        `${this.url}/ExploracionNeurologicaAtencion/GetHipotomia`
      )
      .pipe(map(this.hypotonia.mapFrom));
  }

  override getStaticDinamicEquilibriumNeurology(): Observable<StaticDinamicEquilibriumNeurologyModel> {
    return this.http
      .get<StaticDinamicEquilibriumNeurologyEntity>(
        `${this.url}/ExploracionNeurologicaAtencion/GetEquilibrioEstaticoDinamico`
      )
      .pipe(map(this.staticDinamic.mapFrom));
  }

  override getPlanePostureNeurology(): Observable<PlanePostureNeurologyModel> {
    return this.http
      .get<PlanePostureNeurologyEntity>(
        `${this.url}/ExploracionNeurologicaAtencion/GetPostura`
      )
      .pipe(map(this.planePosture.mapFrom));
  }

  override getTypeAvailableDocument(params: {
    idAtencion: string;
  }): Observable<TypeAvailableDocumentModel> {
    return this.http
      .get<TypeAvailableDocumentEntity>(
        `${this.url}/Atenciones/GetAvailableDocumentsById/${params.idAtencion}`
      )
      .pipe(map(this.typeAvailableDocument.mapFrom));
  }

  override getConsentById(params: {
    idAtencion: string;
    idConsentimientoInformado: string;
  }): Observable<ConsentResponseModel> {
    return this.http
      .post<ConsentResponseEntity>(
        `${this.url}/ConsentimientoInformadoAtencion/Consultar`,
        params
      )
      .pipe(map(this.consentbyId.mapFrom));
  }

  override getConsentPendientById(params: {
    idAtencion: string;
    idConsentimientoInformado: string;
  }): Observable<ConsentResponseModel> {
    return this.http
      .post<ConsentResponseEntity>(
        `${this.url}/ConsentimientoInformadoAtencion/Pendiente`,
        params
      )
      .pipe(map(this.consentbyId.mapFrom));
  }

  override getFacturaTercero(
    params: FacturaTerceroModel
  ): Observable<FacturaTerceroResponseModel> {
    return this.http
      .post<FacturaTerceroResponseEntity>(
        `${this.url}/TercerosEmpresa/Search`,
        params
      )
      .pipe(map(this.facturaTercero.mapFrom));
  }

 override getMedications(params: {
    NombreGenericoDCI: string
  }): Observable<MedicationModel> {
    return this.http
      .get<MedicationEntity>(`${this.url}/FormulacionMedicamentosAtencion/GetMedicamentosByIdEmpresa/${params.NombreGenericoDCI}`)
      .pipe(map(this.medication.mapFrom));
  }


  override getDose(): Observable<DoseModel> {
    return this.http
      .get<DoseEntity>(`${this.url}/FormulacionMedicamentosAtencion/GetDosis`)
      .pipe(map(this.dose.mapFrom));
  }

  override getUnitsTime(): Observable<UnitsTimeModel> {
    return this.http
      .get<UnitsTimeEntity>(`${this.url}/FormulacionMedicamentosAtencion/GetUnidadesTiempo`)
      .pipe(map(this.units.mapFrom));
  }

  override getRoutesAdministration(): Observable<RoutesAdministrationModel> {
    return this.http
      .get<RoutesAdministrationEntity>(`${this.url}/FormulacionMedicamentosAtencion/GetViasAdministracion`)
      .pipe(map(this.routesAdmin.mapFrom));
  }

  override getCalculatedFormula(
    params: CalculatedFormulaRequestModel
  ): Observable<CalculatedFormulaEntity> {
    return this.http
      .post<CalculatedFormulaEntity>(`${this.url}/FormulacionMedicamentosAtencion/GetFormulaCalculada`, params)
      .pipe(map(this.calculatedForm.mapFrom));
  }

  override getTypeProcedure(): Observable<TypeProcedureModel> {
    return this.http
      .get<TypeProcedureEntity>(`${this.url}/FormulacionProcedimientosAtencion/GetTiposProcedimiento`)
      .pipe(map(this.typeProcedure.mapFrom));
  }

  override getProcedureNonSurgical(params: {
    id: string; }): Observable<ProcedureNonSurgicalModel> {
    return this.http
      .post<ProcedureNonSurgicalEntity>(`${this.url}/FormulacionProcedimientosAtencion/GetProcedimientos`, params)
      .pipe(map(this.procedureNonSurgical.mapFrom));
  }

  override insertAttention(
    params: AttentionModel
  ): Observable<AttentionResponseModel> {
    return this.http
      .post<AtenttionResponseEntity>(`${this.url}/Atenciones/Insert`, params)
      .pipe(map(this.attention.mapFrom));
  }

  override insertFacturaTercero(
    params: FacturaTerceroModel
  ): Observable<FacturaTerceroResponseModel> {
    return this.http
      .post<FacturaTerceroResponseEntity>(
        `${this.url}/TercerosEmpresa/Insert`,
        params
      )
      .pipe(map(this.facturaTercero.mapFrom));
  }
  override insertGeneral(
    params: GeneralModel
  ): Observable<GeneralResponseModel> {
    return this.http
      .post<GeneralResponseEntity>(
        `${this.url}/DatosGeneralesAtencion/Insert`,
        params
      )
      .pipe(map(this.general.mapFrom));
  }

  override insertConsult(
    params: ConsultModel
  ): Observable<ConsultResponseModel> {
    return this.http
      .post<ConsultResponseEntity>(
        `${this.url}/DatosConsultaAtencion/Insert`,
        params
      )
      .pipe(map(this.consult.mapFrom));
  }

  override insertBackground(
    params: BackgroundModel
  ): Observable<BackgroundResponseModel> {
    return this.http
      .post<BackgroundResponseEntity>(
        `${this.url}/AntecedentesAtencion/Insert`,
        params
      )
      .pipe(map(this.background.mapFrom));
  }

  override insertDiagnostic(
    params: DataDiagnosticConsultModel[]
  ): Observable<DiagnosticResponseModel> {
    return this.http
      .post<DiagnosticResponseEntity>(
        `${this.url}/DiagnosticosAtencion/Insert`,
        params
      )
      .pipe(map(this.diagnostic.mapFrom));
  }

  override insertRevision(
    params: RevisionConsultModel
  ): Observable<RevisionResponseModel> {
    return this.http
      .post<RevisionResponseEntity>(
        `${this.url}/RevisionesSistemaAtencion/Insert`,
        params
      )
      .pipe(map(this.revision.mapFrom));
  }

  override insertVitalSigns(
    params: VitalSignsConsultModel
  ): Observable<VitalSignsResponseModel> {
    return this.http
      .post<VitalSignsResponseEntity>(
        `${this.url}/SignosVitalesAtencion/Insert`,
        params
      )
      .pipe(map(this.vital.mapFrom));
  }

  override insertVitalSignsMedical(
    params: VitalSignsMedicalConsultModel
  ): Observable<VitalSignsMedicalResponseModel> {
    return this.http
      .post<VitalSignsMedicalResponseEntity>(
        `${this.url}/SignosVitalesMedicinaAlternativaAtencion/Insert`,
        params
      )
      .pipe(map(this.vitalMedical.mapFrom));
  }

  override insertOthers(
    params: OthersConsultModel
  ): Observable<OthersResponseModel> {
    return this.http
      .post<OthersResponseEntity>(`${this.url}/OtrosAtencion/Insert`, params)
      .pipe(map(this.other.mapFrom));
  }

  override insertDocuments(
    params: DocumentsConsultModel[]
  ): Observable<DocumentsResponseModel> {
    return this.http
      .post<DocumentsResponseEntity>(
        `${this.url}/DocumentosAtencion/Insert`,
        params
      )
      .pipe(map(this.documents.mapFrom));
  }

  override insertConfirmation(
    params: ConfirmationModel
  ): Observable<ConfirmationResponseModel> {
    return this.http
      .post<ConfirmationResponseEntity>(
        `${this.url}/Atenciones/EndAttention`,
        params
      )
      .pipe(map(this.confirmation.mapFrom));
  }

  override insertDataInitial(
    params: DataInitialModel
  ): Observable<DataInitialResponseModel> {
    return this.http
      .post<DataInitialResponseEntity>(
        `${this.url}/DatosInicialesAtencion/Insert`,
        params
      )
      .pipe(map(this.dataInitial.mapFrom));
  }

  override insertDevelopment(
    params: DevelopmentModel
  ): Observable<DevelopmentResponseModel> {
    return this.http
      .post<DevelopmentResponseEntity>(
        `${this.url}/DesarrollosAtencion/Insert`,
        params
      )
      .pipe(map(this.development.mapFrom));
  }

    override insertDevelopmentConsult(
    params: DevelopmentConsultOccupationalTherapyModel
  ): Observable<DevelopmentConsultOccupationalTherapyResponseModel> {
    return this.http
      .post<DevelopmentConsultOccupationalTherapyResponseEntity>(`${this.url}/OtrosAtencion/InsertDesarrolloConsulta`, params)
      .pipe(map(this.developmentConsult.mapFrom));
  }

  override insertCardioScreening(
    params: CardiovascularScreeningModel
  ): Observable<CardiovascularScreeningResponseModel> {
    return this.http
      .post<CardiovascularScreeningResponseEntity>(
        `${this.url}/TamizajesCardiovascularAtencion/Insert`,
        params
      )
      .pipe(map(this.vitalCardio.mapFrom));
  }

  override insertProcedure(
    params: ProcedureModel
  ): Observable<ProcedureResponseModel> {
    return this.http
      .post<ProcedureResponseEntity>(
        `${this.url}/ProcedimientosAtencion/Insert`,
        params
      )
      .pipe(map(this.procedure.mapFrom));
  }

  override insertProcedureMedication(
    params: MedicationRequestModel
  ): Observable<ProcedureMedicationResponseModel> {
    return this.http
      .post<ProcedureMedicationResponseEntity>(
        `${this.url}/FormulacionMedicamentosAtencion/Insert`,
        params
      ).pipe(map(this.procedureMedication.mapFrom));
  }

    override insertProcedureAtenttion(
    params: ProcedureAtenttionRequestModel
  ): Observable<ProcedureAtenttionModel> {
    return this.http
      .post<ProcedureAtenttionEntity>(
        `${this.url}/FormulacionProcedimientosAtencion/Insert`,
        params
      ).pipe(map(this.procedureAtenttion.mapFrom));
  }


  override insertInability(
    params: InabilityModel
  ): Observable<InabilityResponseModel> {
    return this.http
      .post<InabilityResponseEntity>(
        `${this.url}/IncapacidadesAtencion/Insert`,
        params
      )
      .pipe(map(this.inability.mapFrom));
  }

  override insertConsultOptometry(
    params: ConsultOptometryModel
  ): Observable<ConsultOptometryResponseModel> {
    return this.http
      .post<ConsultOptometryResponseEntity>(
        `${this.url}/DatosConsultaAtencion/InsertOptometria`,
        params
      )
      .pipe(map(this.consultOptometry.mapFrom));
  }

  override insertBackgroundOptometry(
    params: BackgroundOptometryModel
  ): Observable<BackgroundOptometryResponseModel> {
    return this.http
      .post<BackgroundOptometryResponseEntity>(
        `${this.url}/AntecedentesAtencion/InsertOptometria`,
        params
      )
      .pipe(map(this.backgroundOptometry.mapFrom));
  }

  override insertLensiometry(
    params: LensiometryModel
  ): Observable<LensiometryResponseModel> {
    return this.http
      .post<LensiometryResponseEntity>(
        `${this.url}/LensiometriasAtencion/Insert`,
        params
      )
      .pipe(map(this.lensiometry.mapFrom));
  }

  override insertVisualAcuity(
    params: VisualAcuityModel
  ): Observable<VisualAcuityResponseModel> {
    return this.http
      .post<VisualAcuityResponseEntity>(
        `${this.url}/AgudezasVisualesAtencion/Insert`,
        params
      )
      .pipe(map(this.visual.mapFrom));
  }

  override insertOftalmoscopy(
    params: OftalmoscopyModel
  ): Observable<OftalmoscopyResponseModel> {
    return this.http
      .post<OftalmoscopyResponseEntity>(
        `${this.url}/OftalmoscopiasAtencion/Insert`,
        params
      )
      .pipe(map(this.oftalmoscopy.mapFrom));
  }

  override insertTestExternal(
    params: TestExternalModel
  ): Observable<TestExternalResponseModel> {
    return this.http
      .post<TestExternalResponseEntity>(
        `${this.url}/ExamenesExternosAtencion/Insert`,
        params
      )
      .pipe(map(this.testExternal.mapFrom));
  }

  override insertTestFisical(
    params: TestFisicalModel
  ): Observable<TestFisicalResponseModel> {
    return this.http
      .post<TestFisicalResponseEntity>(
        `${this.url}/ExamenFisicoAtencion/Insert`,
        params
      )
      .pipe(map(this.testFisical.mapFrom));
  }

  override insertBiomicroscopy(
    params: BiomicroscopyModel
  ): Observable<BiomicroscopyResponseModel> {
    return this.http
      .post<BiomicroscopyResponseEntity>(
        `${this.url}/BiomicroscopiasAtencion/Insert`,
        params
      )
      .pipe(map(this.biomicros.mapFrom));
  }

  override insertSurfaceFilm(
    params: SurfaceFilmModel
  ): Observable<SurfaceFilmResponseModel> {
    return this.http
      .post<SurfaceFilmResponseEntity>(
        `${this.url}/SuperficiesOcularesPeliculasLagrimalesAtencion/Insert`,
        params
      )
      .pipe(map(this.surface.mapFrom));
  }

  override insertDeviation(
    params: DeviationModel
  ): Observable<DeviationResponseModel> {
    return this.http
      .post<DeviationResponseEntity>(
        `${this.url}/MedidasDesviacionesHabitualesAtencion/Insert`,
        params
      )
      .pipe(map(this.deviation.mapFrom));
  }

  override insertKerotometry(
    params: KerotometryModel
  ): Observable<KerotometryResponseModel> {
    return this.http
      .post<KerotometryResponseEntity>(
        `${this.url}/QueratometriasAtencion/Insert`,
        params
      )
      .pipe(map(this.keroto.mapFrom));
  }

  override insertRetinoscopy(
    params: RetinoscopyModel
  ): Observable<RetinoscopyResponseModel> {
    return this.http
      .post<RetinoscopyResponseEntity>(
        `${this.url}/RetinoscopiasAtencion/Insert`,
        params
      )
      .pipe(map(this.retinoscopy.mapFrom));
  }

  override insertSubjetive(
    params: SubjetiveModel
  ): Observable<SubjetiveResponseModel> {
    return this.http
      .post<SubjetiveResponseEntity>(
        `${this.url}/SubjetivosAtencion/Insert`,
        params
      )
      .pipe(map(this.subjetive.mapFrom));
  }

  override insertTuning(params: TuningModel): Observable<TuningResponseModel> {
    return this.http
      .post<TuningResponseEntity>(
        `${this.url}/AfinacionesAtencion/Insert`,
        params
      )
      .pipe(map(this.tuning.mapFrom));
  }

  override insertPrescription(
    params: PrescriptionModel
  ): Observable<PrescriptionResponseModel> {
    return this.http
      .post<PrescriptionResponseEntity>(
        `${this.url}/PrescripcionesOpticasAtencion/Insert`,
        params
      )
      .pipe(map(this.prescription.mapFrom));
  }

  override insertMotility(
    params: MotilityModel
  ): Observable<MotilityResponseModel> {
    return this.http
      .post<MotilityResponseEntity>(
        `${this.url}/MotilidadesOcularesAtencion/Insert`,
        params
      )
      .pipe(map(this.motility.mapFrom));
  }

  override insertOthersOptometry(
    params: OthersOptometryModel
  ): Observable<OthersOptometryResponseModel> {
    return this.http
      .post<OthersResponseEntity>(
        `${this.url}/OtrosOptometriasAtencion/Insert`,
        params
      )
      .pipe(map(this.otherOpto.mapFrom));
  }

  override insertBackgroundNeuropsychology(
    params: BackgroundNeuropsychologyModel
  ): Observable<BackgroundNeuropsychologyResponseModel> {
    return this.http
      .post<BackgroundNeuropsychologyResponseEntity>(
        `${this.url}/AntecedentesNeuropsicologiaAtencion/Insert`,
        params
      )
      .pipe(map(this.backgroundNeuropsychology.mapFrom));
  }

  override insertDevelopmentNeuropsychology(
    params: DevelopmentNeuropsychologyModel
  ): Observable<DevelopmentNeuropsychologyResponseModel> {
    return this.http
      .post<DevelopmentNeuropsychologyResponseEntity>(
        `${this.url}/DesarrollosNeuropsicologiaAtencion/Insert`,
        params
      )
      .pipe(map(this.developmentNeuropsychology.mapFrom));
  }

  override insertCompositionNeuropsychology(
    params: CompositionNeuropsychologyModel[]
  ): Observable<CompositionNeuropsychologyResponseModel> {
    return this.http
      .post<CompositionNeuropsychologyResponseEntity>(
        `${this.url}/ComposicionesAmbienteFamiliarNeuropsicologiaAtencion/Insert`,
        params
      )
      .pipe(map(this.compositionNeuropsychology.mapFrom));
  }

  override insertHistoryNeuropsychology(
    params: HistoryScholNeuropsychologyModel
  ): Observable<HistoryScholNeuropsychologyResponseModel> {
    return this.http
      .post<HistoryScholNeuropsychologyResponseEntity>(
        `${this.url}/HistoriasEscolarNeuropsicologiaAtencion/Insert`,
        params
      )
      .pipe(map(this.historyNeuropsychology.mapFrom));
  }

  override insertSpasmPhysiotherapy(
    params: SpasmPhysiotherapyModel
  ): Observable<SpasmPhysiotherapyResponseEntity> {
    return this.http
      .post<SpasmPhysiotherapyResponseEntity>(
        `${this.url}/EspasmosContracturaAtencion/Insert`,
        params
      )
      .pipe(map(this.spasm.mapFrom));
  }

  override insertRehabilitationPhysiotherapy(
    params: RehabilitationPhysiotherapyModel
  ): Observable<RehabilitationPhysiotherapyResponseEntity> {
    return this.http
      .post<RehabilitationPhysiotherapyResponseEntity>(
        `${this.url}/EvaluacionesRehabilitacionAtencion/Insert`,
        params
      )
      .pipe(map(this.rehab.mapFrom));
  }

  override insertMuscleEvaluationPhysiotherapy(
    params: MuscleEvaluationPhysiotherapyModel[]
  ): Observable<MuscleEvaluationPhysiotherapyResponseEntity> {
    return this.http
      .post<MuscleEvaluationPhysiotherapyResponseEntity>(
        `${this.url}/EvaluacionMuscularAtencion/InsertBatch`,
        params
      )
      .pipe(map(this.muscleEva.mapFrom));
  }

  override insertArcMotionPhysiotherapy(
    params: ArcMotionPhysiotherapyModel
  ): Observable<ArcMotionPhysiotherapyResponseEntity> {
    return this.http
      .post<ArcMotionPhysiotherapyResponseEntity>(
        `${this.url}/ArcoMovimientoAtencion/InsertBatch`,
        params
      )
      .pipe(map(this.arcMotions.mapFrom));
  }

  override insertPainScalePhysiotherapy(
    params: PainScalePhysiotherapyModel
  ): Observable<PainScalePhysiotherapyResponseEntity> {
    return this.http
      .post<PainScalePhysiotherapyResponseEntity>(
        `${this.url}/EscalasDolorAtencion/Insert`,
        params
      )
      .pipe(map(this.painScale.mapFrom));
  }

  override insertHealthHabitPhysiotherapy(
    params: HealthHabitPhysiotherapyModel
  ): Observable<HealthHabitPhysiotherapyResponseEntity> {
    return this.http
      .post<HealthHabitPhysiotherapyResponseEntity>(
        `${this.url}/HabitoSaludAtencion/Insert`,
        params
      )
      .pipe(map(this.healthHabit.mapFrom));
  }

  override insertBackgroundPhysiotherapy(
    params: BackgroundPhysiotherapyModel
  ): Observable<BackgroundPhysiotherapyResponseModel> {
    return this.http
      .post<BackgroundResponseEntity>(
        `${this.url}/AntecedentesFisioterapiaAtencion/Insert`,
        params
      )
      .pipe(map(this.backgroundPhysiotherapy.mapFrom));
  }

  override insertDiagnosticMedicalRehabilityPhysiotherapy(
    params: DiagnosticMedicalRehabilityPhysiotherapyModel
  ): Observable<DiagnosticMedicalRehabilityPhysiotherapyResponseModel> {
    return this.http
      .post<DiagnosticMedicalRehabilityPhysiotherapyResponseEntity>(
        `${this.url}/DiagnosticoMedicoRehabilitacionAtencion/Insert`,
        params
      )
      .pipe(map(this.diagnosticMedicalRehabilityPhysiotherapy.mapFrom));
  }

  override insertTransferPhysiotherapy(
    params: TransferPhysiotherapyModel
  ): Observable<TransferPhysiotherapyResponseModel> {
    return this.http
      .post<TransferPhysiotherapyResponseEntity>(
        `${this.url}/TrasladosMarchaDeambulacionAtencion/Insert`,
        params
      )
      .pipe(map(this.transfer.mapFrom));
  }

  override insertAnalysisMarchPhysiotherapy(
    params: AnalysisMarchPhysiotherapyModel
  ): Observable<AnalysisMarchPhysiotherapyResponseModel> {
    return this.http
      .post<AnalysisMarchPhysiotherapyResponseEntity>(
        `${this.url}/AnalisisMarchaAtencion/Insert`,
        params
      )
      .pipe(map(this.analysisMarchPhysiotherapy.mapFrom));
  }

  override insertExplorationNeurology(
    params: ExplorationNeurologyModel
  ): Observable<ExplorationNeurologyResponseModel> {
    return this.http
      .post<ExplorationNeurologyResponseEntity>(
        `${this.url}/ExploracionNeurologicaAtencion/Insert`,
        params
      )
      .pipe(map(this.exploration.mapFrom));
  }

  override updateProcedureMedication(
    params: MedicationRequestModel
  ): Observable<ProcedureMedicationResponseModel> {
    return this.http
      .put<ProcedureMedicationResponseEntity>(
        `${this.url}/FormulacionMedicamentosAtencion/Update`,
        params
      ).pipe(map(this.procedureMedication.mapFrom));
  }


  override updateProcedureAtenttion(
      params: ProcedureAtenttionRequestModel
  ): Observable<ProcedureAtenttionModel> {
    return this.http
      .put<ProcedureAtenttionEntity>(
        `${this.url}/FormulacionProcedimientosAtencion/Update`,
        params
      ).pipe(map(this.procedureAtenttion.mapFrom));
  }

  override updateAttention(
    params: AttentionModel
  ): Observable<AttentionResponseModel> {
    return this.http
      .post<AtenttionResponseEntity>(`${this.url}/Atenciones/Update`, params)
      .pipe(map(this.attention.mapFrom));
  }

  override updateGeneral(
    params: ConsultModel
  ): Observable<ConsultResponseModel> {
    return this.http
      .post<ConsultResponseEntity>(
        `${this.url}/DatosGeneralesAtencion/Update`,
        params
      )
      .pipe(map(this.general.mapFrom));
  }

  override updateConsult(
    params: ConsultModel
  ): Observable<ConsultResponseModel> {
    return this.http
      .post<ConsultResponseEntity>(
        `${this.url}/DatosConsultaAtencion/Update`,
        params
      )
      .pipe(map(this.consult.mapFrom));
  }

  override updateBackground(
    params: BackgroundModel
  ): Observable<BackgroundResponseModel> {
    return this.http
      .post<BackgroundResponseEntity>(
        `${this.url}/AntecedentesAtencion/Update`,
        params
      )
      .pipe(map(this.background.mapFrom));
  }

  override updateDiagnostic(
    params: DataDiagnosticConsultModel[]
  ): Observable<DiagnosticResponseModel> {
    return this.http
      .post<DiagnosticResponseEntity>(
        `${this.url}/DiagnosticosAtencion/Update`,
        params
      )
      .pipe(map(this.diagnostic.mapFrom));
  }

  override updateRevision(
    params: RevisionConsultModel
  ): Observable<RevisionResponseModel> {
    return this.http
      .post<RevisionResponseEntity>(
        `${this.url}/RevisionesSistemaAtencion/Update`,
        params
      )
      .pipe(map(this.revision.mapFrom));
  }

  override updateVitalSigns(
    params: VitalSignsConsultModel
  ): Observable<VitalSignsResponseModel> {
    return this.http
      .post<VitalSignsResponseEntity>(
        `${this.url}/SignosVitalesAtencion/Update`,
        params
      )
      .pipe(map(this.vital.mapFrom));
  }

  override updateVitalSignsMedical(
    params: VitalSignsMedicalConsultModel
  ): Observable<VitalSignsMedicalResponseModel> {
    return this.http
      .put<VitalSignsMedicalResponseEntity>(
        `${this.url}/SignosVitalesMedicinaAlternativaAtencion/Update`,
        params
      )
      .pipe(map(this.vitalMedical.mapFrom));
  }

  override updateOthers(
    params: OthersConsultModel
  ): Observable<OthersResponseModel> {
    return this.http
      .post<OthersResponseEntity>(`${this.url}/OtrosAtencion/Update`, params)
      .pipe(map(this.other.mapFrom));
  }

  override updateDocuments(
    params: DocumentsConsultModel[]
  ): Observable<DocumentsResponseModel> {
    return this.http
      .post<DocumentsResponseEntity>(
        `${this.url}/DocumentosAtencion/Update`,
        params
      )
      .pipe(map(this.documents.mapFrom));
  }

  override updateDataInitial(
    params: DataInitialModel
  ): Observable<DataInitialResponseModel> {
    return this.http
      .post<DataInitialResponseEntity>(
        `${this.url}/DatosInicialesAtencion/Update`,
        params
      )
      .pipe(map(this.dataInitial.mapFrom));
  }

  override updateDevelopment(
    params: DevelopmentModel
  ): Observable<DevelopmentResponseModel> {
    return this.http
      .post<DevelopmentResponseEntity>(
        `${this.url}/DesarrollosAtencion/Update`,
        params
      )
      .pipe(map(this.development.mapFrom));
  }

  override updateCardioScreening(
    params: CardiovascularScreeningModel
  ): Observable<CardiovascularScreeningResponseModel> {
    return this.http
      .put<CardiovascularScreeningResponseEntity>(
        `${this.url}/TamizajesCardiovascularAtencion/Update`,
        params
      )
      .pipe(map(this.vitalCardio.mapFrom));
  }

  override updateProcedure(
    params: ProcedureModel
  ): Observable<ProcedureResponseModel> {
    return this.http
      .put<ProcedureResponseEntity>(
        `${this.url}/ProcedimientosAtencion/Update`,
        params
      )
      .pipe(map(this.procedure.mapFrom));
  }

  override updateInability(
    params: InabilityModel
  ): Observable<InabilityResponseModel> {
    return this.http
      .put<InabilityResponseEntity>(
        `${this.url}/IncapacidadesAtencion/Update`,
        params
      )
      .pipe(map(this.inability.mapFrom));
  }

  override updateConsultOptometry(
    params: ConsultOptometryModel
  ): Observable<ConsultOptometryResponseModel> {
    return this.http
      .post<ConsultOptometryResponseEntity>(
        `${this.url}/DatosConsultaAtencion/UpdateOptometria`,
        params
      )
      .pipe(map(this.consultOptometry.mapFrom));
  }

  override updateBackgroundOptometry(
    params: BackgroundOptometryModel
  ): Observable<BackgroundOptometryResponseModel> {
    return this.http
      .post<BackgroundOptometryResponseEntity>(
        `${this.url}/AntecedentesAtencion/UpdateOptometria`,
        params
      )
      .pipe(map(this.backgroundOptometry.mapFrom));
  }

  override updateLensiometry(
    params: LensiometryModel
  ): Observable<LensiometryResponseModel> {
    return this.http
      .put<LensiometryResponseEntity>(
        `${this.url}/LensiometriasAtencion/Update`,
        params
      )
      .pipe(map(this.lensiometry.mapFrom));
  }

  override updateVisualAcuity(
    params: VisualAcuityModel
  ): Observable<VisualAcuityResponseModel> {
    return this.http
      .put<LensiometryResponseEntity>(
        `${this.url}/AgudezasVisualesAtencion/Update`,
        params
      )
      .pipe(map(this.visual.mapFrom));
  }

  override updateOftalmoscopy(
    params: OftalmoscopyModel
  ): Observable<OftalmoscopyResponseModel> {
    return this.http
      .put<OftalmoscopyResponseEntity>(
        `${this.url}/OftalmoscopiasAtencion/Update`,
        params
      )
      .pipe(map(this.oftalmoscopy.mapFrom));
  }

  override updateTestExternal(
    params: TestExternalModel
  ): Observable<TestExternalResponseModel> {
    return this.http
      .put<TestExternalResponseEntity>(
        `${this.url}/ExamenesExternosAtencion/Update`,
        params
      )
      .pipe(map(this.testExternal.mapFrom));
  }

  override updateTestFisical(
    params: TestFisicalModel
  ): Observable<TestFisicalResponseModel> {
    return this.http
      .post<TestFisicalResponseEntity>(
        `${this.url}/ExamenFisicoAtencion/Update`,
        params
      )
      .pipe(map(this.testFisical.mapFrom));
  }

  override updateBiomicroscopy(
    params: BiomicroscopyModel
  ): Observable<BiomicroscopyResponseModel> {
    return this.http
      .put<BiomicroscopyResponseEntity>(
        `${this.url}/BiomicroscopiasAtencion/Update`,
        params
      )
      .pipe(map(this.biomicros.mapFrom));
  }

  override updateSurfaceFilm(
    params: SurfaceFilmModel
  ): Observable<SurfaceFilmResponseModel> {
    return this.http
      .put<SurfaceFilmResponseEntity>(
        `${this.url}/SuperficiesOcularesPeliculasLagrimalesAtencion/Update`,
        params
      )
      .pipe(map(this.surface.mapFrom));
  }

  override updateDeviation(
    params: DeviationModel
  ): Observable<DeviationResponseModel> {
    return this.http
      .put<DeviationResponseEntity>(
        `${this.url}/MedidasDesviacionesHabitualesAtencion/Update`,
        params
      )
      .pipe(map(this.deviation.mapFrom));
  }

  override updateKerotometry(
    params: KerotometryModel
  ): Observable<KerotometryResponseModel> {
    return this.http
      .put<KerotometryResponseEntity>(
        `${this.url}/QueratometriasAtencion/Update`,
        params
      )
      .pipe(map(this.keroto.mapFrom));
  }

  override updateRetinoscopy(
    params: RetinoscopyModel
  ): Observable<RetinoscopyResponseModel> {
    return this.http
      .put<RetinoscopyResponseEntity>(
        `${this.url}/RetinoscopiasAtencion/Update`,
        params
      )
      .pipe(map(this.retinoscopy.mapFrom));
  }

  override updateSubjetive(
    params: SubjetiveModel
  ): Observable<SubjetiveResponseModel> {
    return this.http
      .put<SubjetiveResponseEntity>(
        `${this.url}/SubjetivosAtencion/Update`,
        params
      )
      .pipe(map(this.subjetive.mapFrom));
  }

  override updateTuning(params: TuningModel): Observable<TuningResponseModel> {
    return this.http
      .put<TuningResponseEntity>(
        `${this.url}/AfinacionesAtencion/Update`,
        params
      )
      .pipe(map(this.tuning.mapFrom));
  }

  override updatePrescription(
    params: PrescriptionModel
  ): Observable<PrescriptionResponseModel> {
    return this.http
      .put<PrescriptionResponseEntity>(
        `${this.url}/PrescripcionesOpticasAtencion/Update`,
        params
      )
      .pipe(map(this.prescription.mapFrom));
  }

  override updateMotility(
    params: MotilityModel
  ): Observable<MotilityResponseModel> {
    return this.http
      .put<MotilityResponseEntity>(
        `${this.url}/MotilidadesOcularesAtencion/Update`,
        params
      )
      .pipe(map(this.motility.mapFrom));
  }

  override updateOthersOptometry(
    params: OthersOptometryModel
  ): Observable<OthersOptometryResponseModel> {
    return this.http
      .put<OthersOptometryResponseEntity>(
        `${this.url}/OtrosOptometriasAtencion/Update`,
        params
      )
      .pipe(map(this.otherOpto.mapFrom));
  }

  override updateBackgroundNeuropsychology(
    params: BackgroundNeuropsychologyModel
  ): Observable<BackgroundNeuropsychologyResponseModel> {
    return this.http
      .put<BackgroundNeuropsychologyResponseEntity>(
        `${this.url}/AntecedentesNeuropsicologiaAtencion/Update`,
        params
      )
      .pipe(map(this.backgroundNeuropsychology.mapFrom));
  }

  override updateDevelopmentNeuropsychology(
    params: DevelopmentNeuropsychologyModel
  ): Observable<DevelopmentNeuropsychologyResponseModel> {
    return this.http
      .put<DevelopmentNeuropsychologyResponseEntity>(
        `${this.url}/DesarrollosNeuropsicologiaAtencion/Update`,
        params
      )
      .pipe(map(this.developmentNeuropsychology.mapFrom));
  }

  override updateCompositionNeuropsychology(
    params: CompositionNeuropsychologyModel[]
  ): Observable<CompositionNeuropsychologyResponseModel> {
    return this.http
      .put<CompositionNeuropsychologyResponseEntity>(
        `${this.url}/ComposicionesAmbienteFamiliarNeuropsicologiaAtencion/Update`,
        params
      )
      .pipe(map(this.compositionNeuropsychology.mapFrom));
  }

  override updateHistoryNeuropsychology(
    params: HistoryScholNeuropsychologyModel
  ): Observable<HistoryScholNeuropsychologyResponseModel> {
    return this.http
      .put<HistoryScholNeuropsychologyResponseEntity>(
        `${this.url}/HistoriasEscolarNeuropsicologiaAtencion/Update`,
        params
      )
      .pipe(map(this.historyNeuropsychology.mapFrom));
  }

  override updateSpasmPhysiotherapy(
    params: SpasmPhysiotherapyModel
  ): Observable<SpasmPhysiotherapyResponseModel> {
    return this.http
      .put<SpasmPhysiotherapyResponseEntity>(
        `${this.url}/EspasmosContracturaAtencion/Update`,
        params
      )
      .pipe(map(this.spasm.mapFrom));
  }

  override updateRehabilitationPhysiotherapy(
    params: RehabilitationPhysiotherapyModel
  ): Observable<RehabilitationPhysiotherapyResponseModel> {
    return this.http
      .put<RehabilitationPhysiotherapyResponseEntity>(
        `${this.url}/EvaluacionesRehabilitacionAtencion/Update`,
        params
      )
      .pipe(map(this.rehab.mapFrom));
  }

  override updatePainScalePhysiotherapy(
    params: PainScalePhysiotherapyModel
  ): Observable<PainScalePhysiotherapyResponseEntity> {
    return this.http
      .put<PainScalePhysiotherapyResponseEntity>(
        `${this.url}/EscalasDolorAtencion/Update`,
        params
      )
      .pipe(map(this.painScale.mapFrom));
  }

  override updateHealthHabitPhysiotherapy(
    params: HealthHabitPhysiotherapyModel
  ): Observable<HealthHabitPhysiotherapyResponseEntity> {
    return this.http
      .put<HealthHabitPhysiotherapyResponseEntity>(
        `${this.url}/HabitoSaludAtencion/Update`,
        params
      )
      .pipe(map(this.healthHabit.mapFrom));
  }

  override updateBackgroundPhysiotherapy(
    params: BackgroundPhysiotherapyModel
  ): Observable<BackgroundPhysiotherapyResponseModel> {
    return this.http
      .put<BackgroundPhysiotherapyResponseEntity>(
        `${this.url}/AntecedentesFisioterapiaAtencion/Update`,
        params
      )
      .pipe(map(this.backgroundPhysiotherapy.mapFrom));
  }

  override updateDiagnosticMedicalRehabilityPhysiotherapy(
    params: DiagnosticMedicalRehabilityPhysiotherapyModel
  ): Observable<DiagnosticMedicalRehabilityPhysiotherapyResponseModel> {
    return this.http
      .put<DiagnosticMedicalRehabilityPhysiotherapyResponseEntity>(
        `${this.url}/DiagnosticoMedicoRehabilitacionAtencion/Update`,
        params
      )
      .pipe(map(this.diagnosticMedicalRehabilityPhysiotherapy.mapFrom));
  }

  override updateAnalysisMarchPhysiotherapy(
    params: AnalysisMarchPhysiotherapyModel
  ): Observable<AnalysisMarchPhysiotherapyResponseModel> {
    return this.http
      .put<AnalysisMarchPhysiotherapyResponseEntity>(
        `${this.url}/AnalisisMarchaAtencion/Update`,
        params
      )
      .pipe(map(this.analysisMarchPhysiotherapy.mapFrom));
  }

  override updateTransferPhysiotherapy(
    params: TransferPhysiotherapyModel
  ): Observable<TransferPhysiotherapyResponseModel> {
    return this.http
      .put<TransferPhysiotherapyResponseEntity>(
        `${this.url}/TrasladosMarchaDeambulacionAtencion/Update`,
        params
      )
      .pipe(map(this.transfer.mapFrom));
  }

  override updateExplorationNeurology(
    params: ExplorationNeurologyModel
  ): Observable<ExplorationNeurologyResponseModel> {
    return this.http
      .put<ExplorationNeurologyResponseEntity>(
        `${this.url}/ExploracionNeurologicaAtencion/Update`,
        params
      )
      .pipe(map(this.transfer.mapFrom));
  }

  override updateDevelopmentConsult(
    params: DevelopmentConsultOccupationalTherapyModel
  ): Observable<DevelopmentConsultOccupationalTherapyResponseModel> {
    return this.http
      .post<DevelopmentConsultOccupationalTherapyResponseEntity>(
        `${this.url}/OtrosAtencion/UpdateDesarrolloConsulta`,
        params
      )
      .pipe(map(this.developmentConsult.mapFrom));
  }

  override cancelAttention(params: { id: string }): Observable<ClientEntity> {
    return this.http
      .post<ClientEntity>(`${this.url}/Atenciones/CancelAttention`, params)
      .pipe(map(this.resume.mapFrom));
  }

  // override generateOTPConsent(params: ConsentConsultModel): Observable<ConsentResponseModel> {
  //     return this.http.post<ConsentResponseEntity>(`${this.url}/ConsentimientoInformadoAtencion/GenerateOTP`, params)
  //     .pipe(map(this.consent.mapFrom));
  // }

  // override validateOTPConsent(params: ConsentConsultModel): Observable<ConsentResponseModel> {
  //     return this.http.post<ConsentResponseEntity>(`${this.url}/ConsentimientoInformadoAtencion/ValidateOTPAndSign`, params)
  //     .pipe(map(this.consent.mapFrom));
  // }

  override sendConsent(
    params: ConsentConsultModel
  ): Observable<ConsentResponseModel> {
    return this.http
      .post<ConsentResponseEntity>(
        `${this.url}/ConsentimientoInformadoAtencion/Enviar`,
        params
      )
      .pipe(map(this.consent.mapFrom));
  }

  override signConsent(
    params: ConsentConsultModel
  ): Observable<ConsentResponseModel> {
    return this.http
      .post<ConsentResponseEntity>(
        `${this.url}/ConsentimientoInformadoAtencion/Firmar`,
        params
      )
      .pipe(map(this.consent.mapFrom));
  }

  override deleteDocument(params: {
    id: string;
  }): Observable<DocumentsResponseModel> {
    return this.http
      .post<DocumentsResponseModel>(
        `${this.url}/DocumentosAtencion/Delete`,
        params
      )
      .pipe(map(this.documents.mapFrom));
  }

  override deleteConsent(params: {
    id: string;
  }): Observable<ConsentResponseModel> {
    return this.http
      .delete<ConsentResponseEntity>(
        `${this.url}/ConsentimientoInformadoAtencion/Delete`,
        { body: params }
      )
      .pipe(map(this.consent.mapFrom));
  }

  override deleteFamilyComposition(params: {
    id: string;
  }): Observable<CompositionNeuropsychologyResponseModel> {
    return this.http
      .post<CompositionNeuropsychologyResponseModel>(
        `${this.url}/ComposicionesAmbienteFamiliarNeuropsicologiaAtencion/Delete`,
        params
      )
      .pipe(map(this.compositionNeuropsychology.mapFrom));
  }

  override deleteRecordSchol(params: {
    id: string;
  }): Observable<HistoryScholNeuropsychologyResponseModel> {
    return this.http
      .post<HistoryScholNeuropsychologyResponseModel>(
        `${this.url}/HistoriasEscolarNeuropsicologiaAtencion/DeleteRecord`,
        params
      )
      .pipe(map(this.historyNeuropsychology.mapFrom));
  }

  override deleteMuscleEvaluationPhysiotherapy(params: {
    id: string;
  }): Observable<MuscleEvaluationPhysiotherapyResponseModel> {
    return this.http
      .delete<MuscleEvaluationPhysiotherapyResponseModel>(
        `${this.url}/EvaluacionMuscularAtencion/Delete`,
        { body: params }
      )
      .pipe(map(this.muscleEva.mapFrom));
  }

  override deleteArcMotionPhysiotherapy(params: {
    id: string;
  }): Observable<ArcMotionPhysiotherapyResponseModel> {
    return this.http
      .delete<ArcMotionPhysiotherapyResponseModel>(
        `${this.url}/ArcoMovimientoAtencion/Delete`,
        { body: params }
      )
      .pipe(map(this.arcMotions.mapFrom));
  }

  override createPendingHCDListById(params: { id: string }): Observable<DocumentsResponseEntity> {
    return this.http
      .post<DocumentsResponseEntity>(`${this.url}/Atenciones/CreatePendingHCDListById`, params)
      .pipe(map(this.resume.mapFrom));
  }

  override createTeleconsulta(params: { id: string, id2: string, descripcion: string }): Observable<TeleconsultaInsertResponseEntity> {
    return this.http
      .post<TeleconsultaInsertResponseEntity>(`${this.url}/Teleconsulta/CreateTeleconsulta`, params)
      .pipe(map(this.teleconsultaInsert.mapFrom));
  }

  override activateTeleconsulta(params: { id: string, descripcion: string }): Observable<TeleconsultaActivateResponseEntity> {
    return this.http
      .post<TeleconsultaActivateResponseEntity>(`${this.url}/Teleconsulta/ActivateRoom`, params)
      .pipe(map(this.teleconsultaActivate.mapFrom));
  }

  override getTeleconsultaById(params: { idAtencion: string }): Observable<TeleconsultaModel> {
    return this.http.get<TeleconsultaEntity>(
      `${this.url}/Teleconsulta/GetTeleconsultaById/${params.idAtencion }`
    )
      .pipe(map(this.teleconsulta.mapFrom));
  }

  /*REPROCESO DOCUMENTOS PDF*/

   override getAttentionReprocess(params:FiltersReprocessDocumentsModel): Observable<ReprocessDocumentsAttentionResponseEntity> {
    return this.http
      .post<ReprocessDocumentsAttentionResponseEntity>(`${this.url}/Atenciones/GetAttentionsToReprocess`, params)
      .pipe(map(this.reprocessAttentionList.mapFrom));
  }

   override activateDocumentReprocess(params: ReprocessStartRequestModel): Observable<ReprocessStartResponseEntity> {
    return this.http
      .post<ReprocessStartResponseEntity>(`${this.url}/Atenciones/ReprocessDocuments`, params)
      .pipe(map(this.reprocessDocumentStart.mapFrom));
  }

    override getAttentionState(): Observable<AttentionStateModel> {
     return this.http
      .get<AttentionStateEntity>(`${this.url}/Atenciones/GetAllEstadoAtencion`)
      .pipe(map(this.attentionState.mapFrom));
    }

  }
